import { BreakpointRangeName } from './BreakpointRangeName';
import { DESKTOP, LARGE_DESKTOP, PHONE, TABLET } from './constants';
import { BreakpointRange as MewsBreakpointRange } from './types';

export const BreakpointRange: MewsBreakpointRange = {
    [BreakpointRangeName.SmallPhone]: {
        low: 0,
        high: PHONE - 1,
    },
    [BreakpointRangeName.Phone]: {
        low: PHONE,
        high: TABLET - 1,
    },
    [BreakpointRangeName.Tablet]: {
        low: TABLET,
        high: DESKTOP - 1,
    },
    [BreakpointRangeName.Desktop]: {
        low: DESKTOP,
        high: LARGE_DESKTOP - 1,
    },
    [BreakpointRangeName.LargeDesktop]: {
        low: LARGE_DESKTOP,
        high: 2 ** 31 - 2,
    },
};

export type MediaQuery = keyof typeof MEDIA_QUERY;
export const MEDIA_QUERY = {
    phoneOnly: `@media screen and (max-width: ${BreakpointRange.SmallPhone.high}px)`,

    largePhoneUp: `@media screen and (min-width: ${BreakpointRange.Phone.low}px)`,
    largePhoneOnly: `@media screen and (min-width: ${BreakpointRange.Phone.low}px) and (max-width: ${BreakpointRange.Phone.high}px)`,
    largePhoneMax: `@media screen and (max-width: ${BreakpointRange.Phone.high}px)`,

    tabletUp: `@media screen and (min-width: ${BreakpointRange.Tablet.low}px)`,
    tabletOnly: `@media screen and (min-width: ${BreakpointRange.Tablet.low}px) and (max-width: ${BreakpointRange.Tablet.high}px)`,
    tabletMax: `@media screen and (max-width: ${BreakpointRange.Tablet.high}px)`,

    desktopUp: `@media screen and (min-width: ${BreakpointRange.Desktop.low}px)`,
    desktopOnly: `@media screen and (min-width: ${BreakpointRange.Desktop.low}px) and (max-width: ${BreakpointRange.Desktop.high}px)`,
    desktopMax: `@media screen and (max-width: ${BreakpointRange.Desktop.high}px)`,

    largeDesktopOnly: `@media screen and (min-width: ${BreakpointRange.LargeDesktop.low}px)`,
    largeDesktopMax: `@media screen and (max-width: ${BreakpointRange.LargeDesktop.high}px)`,
    print: '@media print',
} as const;
